import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import "src/styles/Calendar.css"; // css import
import moment from "moment";
import "moment/locale/ko";
import Body from "src/components/common/Body";
import Box from "src/components/common/Box";
import TextInput from "src/components/common/TextInput";
import Button from "src/components/common/Button";
import BottomModal, { RefProps } from "src/components/common/BottomModal";
import styled from "styled-components";
import { useAddVisitMutation, useSelectVisitInfoQuery, useUpdateVisitMutation } from "src/api/asAPI";
import { VisitVo } from "src/vo/visitVo";
import { getPathValue } from "src/utils/queryStringUtil";
import { useNavigate, useLocation } from "react-router-dom";
import Textarea from "src/components/common/Textarea";
import { useAppSelector } from "src/store/actions/action";
import { isEmpty } from "lodash";
import queryString from "query-string";

function visitInfo() {
  const navigate = useNavigate();
  const { search, state } = useLocation();
  const stateData: any = state;
  const queryParser = queryString.parse(search);
  const rnData = queryParser["rn"];

  const userInfo = useAppSelector((state) => state.userReduce.userInfo);

  const [inValidUser, setInValidUser] = useState(userInfo.user_type === "E" || userInfo.user_type === "S");

  const index: any = getPathValue();

  const [inputs, setInputs] = useState<VisitVo>({
    as_idx: index,
    visit_date: "",
    visitor_name: "",
    visitor_birth: "",
    phone_number: undefined,
    car_number: "",
    etc: "",
  });
  const [isIorU, setIsIorU] = useState<boolean>(false);

  const [deleteYn, setDeleteYn] = useState<string>();

  const [asc, setAsc] = useState<string>();

  useEffect(() => {
    if (!isEmpty(state)) {
      setDeleteYn(stateData.deleteYn);
      setAsc(stateData.asc);
      if (stateData.asc === "ASC_100") {
        setInValidUser(true);
      }
    }

    window.scrollTo(0, 0);
  }, []);

  const visitInfo = useSelectVisitInfoQuery(index);

  useEffect(() => {
    if (visitInfo.isSuccess) {
      if (!isEmpty(visitInfo.data)) {
        setIsIorU(true);
        setInputs({
          ...inputs,
          visit_date: visitInfo.data.visit_date?.replaceAll("-", "."),
          visitor_name: visitInfo.data.visitor_name,
          visitor_birth: visitInfo.data.visitor_birth?.replaceAll("-", ""),
          phone_number: visitInfo.data.phone_number,
          car_number: visitInfo.data.car_number,
          etc: visitInfo.data.etc,
        });
      }
    }
  }, [visitInfo]);

  const [insertStart, { error, isSuccess }] = useAddVisitMutation();
  const [updateStart, { isError: updateIsError, isSuccess: updateIsSuccess }] = useUpdateVisitMutation();

  const onChange = (e: any) => {
    const { value, id } = e.target;
    let setValue = "";
    if (id === "visitor_birth" || id === "phone_number") {
      setValue = value.replace(/[^0-9]/g, "");
    } else if (id === "visitor_name") {
      setValue = value.replace(/[a-z0-9]|[ \[\]{}()<>?|`~!@#$%^&*-_+=,.;:\"'\\]/g, "");
    } else {
      setValue = value;
    }

    setInputs({
      ...inputs,
      [id]: setValue,
    });
  };

  const { visit_date, visitor_name, visitor_birth, phone_number, car_number, etc } = inputs;

  const CaleanderOnClick = (e: any) => {
    if (calendarRef.current) calendarRef.current.modalClose();
    document.body.style.overflow = "unset";
    const dateFormat = moment(e).format("YYYY.MM.DD");
    setInputs({
      ...inputs,
      visit_date: dateFormat,
    });
  };

  const addVisit = async () => {
    if (!visit_date) {
      alert("방문예정일을 선택해주세요");
      return;
    }
    if (!visitor_name) {
      alert("작업자 이름을 입력해 주세요");
      return;
    }
    if (!visitor_birth) {
      alert("생년월일을 입력해 주세요");
      return;
    }
    if (!phone_number) {
      alert("휴대폰 번호를 입력해 주세요");
      return;
    }
    if (!car_number) {
      alert("차량번호를 입력해 주세요");
      return;
    }
    if (visitor_birth.length < 6) {
      alert("생년월일 규격을 맞춰 주세요 ex)19901231 혹은 901231");
      return;
    }

    if (isIorU) {
      await updateStart(inputs);
    } else {
      await insertStart(inputs);
    }
  };

  useEffect(() => {
    if (isSuccess) {
      alert("방문 등록 완료");
      // location.replace("/as-detail/" + index);
      navigate("/as-detail/" + index, { replace: true });
    }
  }, [isSuccess]);

  useEffect(() => {
    if (updateIsSuccess) {
      alert("방문 정보 수정 완료");
      navigate("/as-detail/" + index);
    }
  }, [updateIsSuccess]);

  useEffect(() => {
    if (error) {
      alert("시스템 오류 입니다. 다시 시도해 주시기 바랍니다.");
    }
  }, [error]);

  const backClick = () => {
    if (!isEmpty(rnData)) {
      navigate("/as-detail/" + index);
    } else {
      navigate(-1);
    }
  };

  // +++++++++++++++++++++++++++++ 퍼블리싱 영역 +++++++++++++++++++++++++++++
  const [date, setDate] = useState(new Date());
  const calendarRef = React.useRef<RefProps>(null);

  const openDatepicker = () => {
    if (inValidUser) return;
    if (calendarRef.current) calendarRef.current.modalOpen();
    document.body.style.overflow = "hidden";
  };

  return (
    <>
      <header>
        <div>
          <Button variant="text" className="btn-back" onClick={() => backClick()}>
            방문정보
          </Button>
        </div>
      </header>

      <Body type="detail">
        {/* 방문정보 작성 후 인풋태그에 readonly 속성 추가 */}
        <Box pd="50px 45px">
          <TextInput
            require={true}
            type="text"
            id="visit_date"
            name="visit_date"
            label="방문예정일"
            placeholder="ex)2022.02.25"
            maxLength={10}
            value={visit_date}
            readonly
            onClick={openDatepicker}
            onChange={(e) => onChange(e)}
          />
          <TitleSet>
            <p>대표 작업자 정보</p>
          </TitleSet>
          <TextInput
            require={true}
            type="text"
            id="visitor_name"
            name="visitor_name"
            value={visitor_name}
            label="작업자"
            maxLength={8}
            placeholder="홍길동"
            onChange={(e) => onChange(e)}
            readonly={inValidUser}
          />
          <TextInput
            require={true}
            type="text"
            pattern="\d*"
            id="visitor_birth"
            name="visitor_birth"
            value={visitor_birth}
            label="생년월일"
            maxLength={8}
            placeholder="ex)19950329"
            onChange={(e) => onChange(e)}
            readonly={inValidUser}
          />
          <TextInput
            require={true}
            type="tel"
            id="phone_number"
            name="phone_number"
            value={phone_number}
            maxLength={11}
            label="휴대폰"
            placeholder="숫자만입력 ex)01012345678"
            onChange={(e) => onChange(e)}
            readonly={inValidUser}
          />
          <TextInput
            require={true}
            type="text"
            id="car_number"
            name="car_number"
            value={car_number}
            label="차량번호"
            maxLength={8}
            placeholder="ex)00가1234"
            onChange={(e) => onChange(e)}
            readonly={inValidUser}
          />
          {/* {inValidUser && etc && etc.length > 0 && (
            <>
            <InfoLabel htmlFor="more_info">추가 작업자 정보</InfoLabel>
          <InfoTextArea id="etc" value={etc} placeholder="1. 김하나 : 1900.01.01, 010-1234-1111" onChange={(e) => onChange(e)} readOnly={inValidUser} />
            </>
          )} */}
          <InfoLabel htmlFor="more_info">추가 작업자 정보</InfoLabel>
          <InfoTextArea
            id="etc"
            value={etc}
            placeholder={isEmpty(etc) && userInfo.user_type === "M" ? "1. 김하나 : 1900.01.01, 010-1234-1111" : ""}
            onChange={(e) => onChange(e)}
            readOnly={inValidUser}
          />
        </Box>

        {/* 업체만 완료 버튼 -> 그외 본사, 매장은 확인으로 텍스트 변경 */}
        {/* 업체외 다른 사용자는 등록 불가 */}
        {userInfo.user_type === "M" && (
          <>
            {deleteYn !== "Y" && asc !== "ASC_100" ? (
              <Box pd="65px 45px 60px">
                <Button variant="contained" br="round" onClick={() => addVisit()}>
                  {isIorU ? "수정" : "등록"}
                </Button>
              </Box>
            ) : (
              ""
            )}
          </>
        )}
      </Body>

      <BottomModal ref={calendarRef} modalTitle="방문예정일 지정" footerBtn="완료">
        <Box pd="15px">
          <Calendar
            onChange={setDate}
            minDetail="decade"
            formatMonthYear={(locale, date) => moment(date).format("YYYY. MM")}
            formatDay={(locale, date) => moment(date).format("D")} // 날 표시할때 '일', 0 제외하고 숫자만 보이도록 설정
            value={date}
            showNeighboringMonth={false} //  전달, 다음달 날짜 표시 안함
            calendarType="US" // 주의 첫번째 요일 일요일부터 시작
            onClickDay={(e) => CaleanderOnClick(e)}
          />
        </Box>
      </BottomModal>
    </>
  );
}

const TitleSet = styled.div`
  padding-bottom: 10px;
  margin: 50px 0 30px;
  border-bottom: 2px solid #000;
  > p {
    font-size: 16px;
    font-weight: 700;
  }
`;

const InfoLabel = styled.label`
  display: inline-block;
  margin-top: 50px;
  padding-bottom: 10px;
  position: relative;
  font-size: 16px;
  font-weight: bold;
`;

const InfoTextArea = styled.textarea.attrs({})`
  width: 100%;
  height: 150px;
  padding: 15px;
  border: none;
  border-top: 1px solid #000;
  border-radius: 0 0 4px 4px;
  background: #f4f4f4;
  resize: none;
  outline: none;
  color: #001827;
  font-size: 16px;
  font-family: "Roboto";
  font-weight: 400;
  &::placeholder {
    font-size: 14px;
    opacity: 50%;
  }
  &[readonly],
  &[readonly="readonly"] {
    padding: 10px 0px;
    border: none;
    background: none;
    &::placeholder {
      color: ${({ theme }) => theme.color.secondary};
      font-size: 16px;
      opacity: 100%;
    }
  }
`;

export default visitInfo;
